import { Field } from '@app/api/types'
import { apiSdk } from '@app/api/endpoints'
import { AppDispatch } from '@app/store/store'
import catchErrorHandler from '@app/store/utils/catchErrorHandler'
import { useCheckSetFieldValueResponse } from '@app/hooks/useCheckSetFieldValueResponse'
import { runtimeConfig } from '@app/common/config'

import { actions } from './slice'
import { SetFieldValueMutation } from '@app/graphql/service/schema'

const {
  requestUpdateMchatInputData,
  successUpdateMchatInputData,
  errorUpdateMchatInputData,
  requestMchatCompleted,
  successMchatCompleted,
  errorMchatCompleted
} = actions

const CHANNEL_ID = runtimeConfig.joinSproutTherapyConfig?.CHANNEL_ID

export const updateValue = (sessionId: string, field: Field) => async (dispatch: AppDispatch) => {
  dispatch(requestUpdateMchatInputData())

  try {
    await setFieldValue(sessionId, field, useCheckSetFieldValueResponse)
    dispatch(successUpdateMchatInputData(field))
  } catch (error) {
    catchErrorHandler(error, dispatch, errorUpdateMchatInputData)
  }
}

export const completeMchat = (sessionId: string, fieldCurrentDate: Field, fieldTestAnswers: Field) => async (
  dispatch: AppDispatch
) => {
  dispatch(requestMchatCompleted())
  try {
    await setFieldValue(sessionId, fieldCurrentDate, useCheckSetFieldValueResponse)
    await setFieldValue(sessionId, fieldTestAnswers, useCheckSetFieldValueResponse)
    await apiSdk.MchatCompleted({ channelId: CHANNEL_ID, sessionId })
    dispatch(successMchatCompleted)
  } catch (error) {
    catchErrorHandler(error, dispatch, errorMchatCompleted)
  }
}

const setFieldValue = async (
  sessionId: string,
  field: Field,
  responseHandler: (response: SetFieldValueMutation) => void
) => {
  if (field.apiFieldKey) {
    const response = await apiSdk.SetFieldValue({
      channelId: CHANNEL_ID,
      sessionId,
      field: field.apiFieldKey,
      value: field.fieldValue
    })

    responseHandler(response)
  }
}
